/**
 * 目前登入者 id（供少數要求 `X-User-Id` 的 API，例 FMS 異動）。
 * 由 configureStore 注入 getter，避免 api 層直接 import store（循環依賴）。
 */
let actorIdGetter = null;

export function setSessionActorGetter(getter) {
  actorIdGetter = typeof getter === 'function' ? getter : null;
}

export function getSessionActorId() {
  const id = actorIdGetter?.();
  return id ? String(id) : null;
}
